const METADATA_FILE_RE =
  /^(\d{4}-\d{2}-\d{2}T\d{2})-(\d{2})-(\d{2}(?:\.\d+)?Z)-[^/]+\.json$/;

export function metadataTimestampFromName(name = "") {
  const match = String(name).match(METADATA_FILE_RE);
  if (!match) return null;

  const iso = `${match[1]}:${match[2]}:${match[3]}`;
  const ms = Date.parse(iso);
  return Number.isFinite(ms) ? ms : null;
}

export function isNewerMetadataName(candidate, current) {
  if (!current) return true;
  return String(candidate).localeCompare(String(current)) > 0;
}
